









import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import store from "@/shared/core/store";
import { isEmbedded } from "@/shared/core/embed";

@Component
export default class CleanLayout extends Vue {
  logoUrl: string | null = null;
  embedded: boolean = false;

  // Embedded in the tenant's own site: the host page already shows its branding.
  get showHeader() {
    return !this.embedded && this.logoUrl !== null;
  }

  // A broken image is worse than no header at all.
  onLogoError() {
    this.logoUrl = null;
  }

  mounted() {
    this.embedded = isEmbedded();
    const shared = store.state.settings;
    if (shared.Mainlogo) {
      // settings.Uploads can carry a duplicated slash (its path part already starts with
      // one), and that 404s. Collapse repeated slashes without touching the scheme.
      this.logoUrl = (shared.Uploads + "/" + shared.Mainlogo).replace(/([^:]\/)\/+/g, "$1");
    }
    // Same theming the rest of the customer zone applies, so buttons and accents use
    // the tenant's colour instead of the stylesheet default.
    if (shared.ButtonsColor) {
      document.documentElement.style.setProperty("--main-color", shared.ButtonsColor);
    }
    if (shared.FontFamily) {
      document.documentElement.style.setProperty("--main-family", shared.FontFamily);
    }
  }
}
